module.exports = __webpack_public_path__ + "static/media/karthik-krishna.09c5f2cb.png";